import ConfigCharts from '@/language/en/components/config/ConfigCharts';
import ConfigContract from '@/language/en/components/config/ConfigContract';
import ConfigModal from '@/language/en/components/config/ConfigModal';
import ConfigStyle from '@/language/en/components/config/ConfigStyle';
import ConfigUsers from '@/language/en/components/config/ConfigUsers';
import IntegrationToken from '@/language/en/components/config/IntegrationToken';

export default {
  ConfigCharts,
  ConfigContract,
  ConfigModal,
  ConfigStyle,
  ConfigUsers,
  IntegrationToken,
};
